export enum FontWeights {
  thin = 100,
  extraLight = 200,
  light = 300,
  regular = 400,
  medium = 500,
  semiBold = 600,
  bold = 700,
  extraBold = 800,
  black = 900,
}

export enum FontStyles {
  normal = 'normal',
  italic = 'italic',
  oblique = 'oblique',
}

export type FontSrcFormat = 'woff2' | 'woff' | 'truetype'

export type Font = {
  fontFamily: string
  fontWeight?: FontWeights
  fontStyle?: FontStyles
  fallback?: string
  /** When set with `src`, legacy basename-based URLs are not used. */
  basename?: string
  /** Path under site root, e.g. `/fonts/BbComputer/BB-Regular.ttf` */
  src?: string
  srcFormat?: FontSrcFormat
}

export const defineFont = (font: Font): string => `
    font-family: "${font.fontFamily}", ${font.fallback || 'sans-serif'};
    font-weight: ${font.fontWeight || FontWeights.regular};
    font-style: ${font.fontStyle || FontStyles.normal};
  `

export const declareFont = (font: Font): string => {
  const { basename, fontFamily, fontWeight, fontStyle, src, srcFormat } = font

  let srcBlock: string
  if (src && srcFormat) {
    srcBlock = `url("${src}") format("${srcFormat}")`
  } else if (src) {
    srcBlock = `url("${src}") format("woff2")`
  } else if (basename) {
    const path = `/fonts/${basename}/${basename}`
    srcBlock = `url("${path}.woff2") format("woff2"),
          url("${path}.woff") format("woff")`
  } else {
    throw new Error('Font must define either `src` or `basename` for @font-face')
  }

  return `
      @font-face {
        font-family: "${fontFamily}";
        font-display: swap;
        font-weight: ${fontWeight || FontWeights.regular};
        font-style: ${fontStyle || FontStyles.normal};
        src: ${srcBlock};
      }
    `
}
